module.exports = __webpack_public_path__ + "img/146.961b3508.jpg";